<!--  -->
<template>
  <div class="content">
    <div class="top_all">
          <img src="../assets/img/index/ico.png" alt="" />
          <div class="text">{{text}}</div>
        </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["text", "one"],
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
.top_all {
  .text {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 49px;
    text-align: center;
    padding: 25px 0 0 0;
    //  width: 133px !important;
  }
  // 小屏幕
@media (max-width: 1279px) {
  .text {
    font-size: 22px !important;
    }
  
}

  .fff {
    color: #FFFFFF;

  }

  img {
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
</style>
// 小屏幕
@media (max-width: 1279px) {
  
}
// 中屏幕
@media screen and (max-width: 1600px) and (min-width:1280px) {
 
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: 1600px) {
 
}